module.exports = __webpack_public_path__ + "img/loan_img_3.6978bb01.png";